export interface CallHistory {
  id: number | null;
  outboundDate: string;
  memo: string;
}
export interface BasicInformationInputInitialValues {
  memoAD: string;
  memoSV: string;
  isSmsSendingRequired: string;
  responseStatus: string;
  policyNumberRevised: string;
  nameRevised: string;
  nameKanaRevised: string;
  memo: string;
  callFlg: boolean;
  callDesignatedDate: string | null;
  callDesignatedTimeAndMemo: string | null;
  callHistories: CallHistory[];
  isIdentifiedAll: number | null;
}

export const basicInformationInputInitialValues: BasicInformationInputInitialValues = {
  memoAD: '',
  memoSV: '',
  isSmsSendingRequired: '2',
  responseStatus: '1',
  policyNumberRevised: '',
  nameRevised: '',
  nameKanaRevised: '',
  memo: '',
  callFlg: false,
  callDesignatedDate: null,
  callDesignatedTimeAndMemo: null,
  callHistories: [],
  isIdentifiedAll: null,
};
